import { useCallback, useEffect, useState } from "react";
import useYear from "../../../../hooks/Year";
import { getRequestGraphSectionArea } from "../../../../config";
import { getSelectArea } from "../util/graphAreaUtil";


const useGraphArea = () => {
    const { listOfYears, updateYear, year } = useYear(5);
    const [currentStep, setCurrentStep] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [dataAreas, setDataAreas] = useState([])
    const [selectArea, setSelectArea] = useState({
        folderBreakdown: [],
        listBarContainer: [],
        barBreakdown: [],
        keysBarBreakdown: [],
    })

    const onChangeTab = (currentStep) => {
        const areaSelect = dataAreas[currentStep];
        const selectArea = getSelectArea(areaSelect)
        setSelectArea(selectArea)
        setCurrentStep(currentStep);
    };

    const realoadPage = useCallback(
        () => {
            setIsLoading(true);
            getRequestGraphSectionArea(year)
                .then(({ status, payload: sections }) => {
                    if (status !== 0) return;
                    if (sections.length === 0) {
                        setCurrentStep(0)
                        setSelectArea({
                            folderBreakdown: [],
                            listBarContainer: [],
                            barBreakdown: [],
                            keysBarBreakdown: [],
                        })
                        setDataAreas([])
                        return;
                    };
                    const selectArea = getSelectArea(sections[currentStep])
                    setSelectArea(selectArea)
                    setDataAreas(sections)
                })
                .catch((error) => console.error(error))
                .finally(() => setIsLoading(false));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [year],
    )


    useEffect(() => realoadPage(), [realoadPage])


    return {
        listOfYears,
        year,
        updateYear,
        currentStep,
        onChangeTab,
        isLoading,
        dataAreas,
        selectArea,
    }
}

export default useGraphArea